module.exports = __webpack_public_path__ + "img/flickr-light.10844b2d.svg";